import React from 'react'
import styled, {keyframes} from 'styled-components'
import {ScrollArea, Text} from '../../..'
import {themeGet} from '../../..'

export const StyledScrollArea = styled(ScrollArea)`
  width: 200px;
  height: 225px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: ${themeGet('shadows.elevation.shadow.overlay')};
  background-color: ${themeGet('colors.elevation.surface.default.[default]')};
  --scrollbar-size: 10px;
`
export const StyledScrollAreaViewport = styled(ScrollArea.Viewport)`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  //
`
export const StyledScrollAreaScrollbar = styled(ScrollArea.Scrollbar)`
  display: flex;
  /* ensures no selection */
  user-select: none;
  /* disable browser handling of all panning and zooming gestures on touch devices */
  touch-action: none;
  padding: 2px;
  background-color: ${themeGet('colors.background.accent.teal.subtler')};
  transition: background-color 160ms ease-out;
  &:hover {
    background-color: ${themeGet('colors.background.accent.teal.bolder')};
  }
  &[data-orientation='vertical'] {
    width: var(--scrollbar-size);
  }
  &[data-orientation='horizontal'] {
    flex-direction: column;
    height: var(--scrollbar-size);
  }
`
export const StyledScrollAreaThumb = styled(ScrollArea.Thumb)`
  flex: 1;
  background-color: ${themeGet('colors.background.accent.blue.bolder')};
  border-radius: var(--scrollbar-size);
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    min-width: 44px;
    min-height: 44px;
  }
`
/* increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html */
export const StyledTag = styled(Text)`
  color: ${themeGet('colors.text.default')};
  font-size: ${themeGet('fontSizes.3')};
  line-height: ${themeGet('lineHeights.default')};
  margin-top: ${themeGet('space.3')};
  /* border-top: 1px solid ${themeGet('colors.border.accent.teal')}; */
  padding-top: ${themeGet('space.2')};
`

// temp animations
const fadeIn = keyframes`
  from {
    transform: scale(0.2);
    opacity: 0
};
  to {
    transform: scale(1);
  opacity: 1
  }
`
const fadeOut = keyframes`
  from {
    transform: scale(1);
   opacity: 1
};
  to {
    transform: scale(0.2);
   opacity: 0
  }
`
// temp styles
const SCROLLBAR_SIZE = 8
//
export const StyledRadixScrollArea = styled(ScrollArea)`
  width: 100%;
  height: 100%;
  border: '1px solid ${themeGet('colors.border.default')}';
`
export const StyledRadixScrollAreaViewport = styled(ScrollArea.Viewport)`
  width: 100%;
  height: 100%;
`
export const StyledRadixScrollAreaScrollbar = styled(ScrollArea.Scrollbar)`
  display: flex;
  // ensures no selection
  user-select: none;
  // disable browser handling of all panning and zooming gestures on touch devices
  touch-action: none;
  padding: ${themeGet('space.2')};
  background-color: ${themeGet('colors.background.neutral.bold.default')};
  transition: background-color 160ms ease-out;
  &:hover {
    background: ${themeGet('colors.background.neutral.bold.hovered')};
  }
  &[data-orientation='vertical'] {
    width: ${SCROLLBAR_SIZE};
  }
  &[data-orientation='horizontal'] {
    flex-direction: column;
    height: ${SCROLLBAR_SIZE};
  }
`
export const StyledRadixScrollAreaThumb = styled(ScrollArea.Thumb)`
  flex: 1;
  // increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html
  position: relative;
  background-color: ${themeGet('colors.background.accent.blue.bolder')};
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    min-width: 44;
    min-height: 44;
  }
  //
  border-radius: ${SCROLLBAR_SIZE};
`
export const StyledRadixAnimatedScrollAreaThumb = styled(ScrollArea.Thumb)`
  flex: 1;
  // increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html
  position: relative;
  background-color: ${themeGet('colors.background.accent.blue.bolder')};
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    min-width: 44;
    min-height: 44;
  }
  //
  border-radius: ${SCROLLBAR_SIZE};

  &[data-state='visible'] {
    animation: ${fadeIn} 300ms ease;
  }
  &[data-state='hidden'] {
    animation: ${fadeOut} 300ms ease;
  }
`
export const StyledRadixScrollAreaCorner = styled(ScrollArea.Corner)`
  background-color: deeppink;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: black;
    width: ${SCROLLBAR_SIZE};
    height: ${SCROLLBAR_SIZE};
    border-radius: ${SCROLLBAR_SIZE};
  }
`
